var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74953 2.75586L6.03959 6.04592M19.2495 19.2559L15.9598 15.9661M12.7182 17.2618C12.1616 17.3673 11.5872 17.4225 11 17.4225C6.89544 17.4225 3.421 14.7249 2.25293 11.0058C2.57092 9.9934 3.05983 9.05667 3.68585 8.22944M9.05499 9.06132C9.55264 8.56366 10.2401 8.25586 10.9995 8.25586C12.5183 8.25586 13.7495 9.48708 13.7495 11.0059C13.7495 11.7653 13.4417 12.4528 12.9441 12.9504M9.05499 9.06132L12.9441 12.9504M9.05499 9.06132L6.03959 6.04592M12.9441 12.9504L6.03959 6.04592M12.9441 12.9504L15.9598 15.9661M6.03959 6.04592C7.46943 5.12411 9.17222 4.58919 10.9999 4.58919C15.1045 4.58919 18.5789 7.28686 19.747 11.0059C19.099 13.069 17.7412 14.8178 15.9598 15.9661",
    stroke: "#9997AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide_password.490045dbbca77de2d4c8ff327e062219.svg";
export { ForwardRef as ReactComponent };